module.exports = __webpack_public_path__ + "img/L11.f7a5580.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L11.png
// module id = iKpW
// module chunks = 0